(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('seriva-cart-drawer')) {
    customElements.define('seriva-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.dialog = this.querySelector('[data-cart-dialog]');
        this.closeButton = this.querySelector('[data-cart-close]');
        this.pointerFocus = false;
        this.returnFocusTo = null;
        document.documentElement.classList.add('cart-enhanced');
        document.addEventListener('click', (event) => this.handleClick(event), { signal });
        document.addEventListener('pointerdown', () => { this.pointerFocus = true; }, { signal });
        document.addEventListener('change', (event) => this.handleChange(event), { signal });
        document.addEventListener('submit', (event) => this.handleSubmit(event), { capture: true, signal });
        document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
        this.dialog?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, { signal });
        this.dialog?.addEventListener('close', () => this.afterClose(), { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        }, { signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      handleClick(event) {
        const opener = event.target.closest('[data-cart-open]');
        if (opener) {
          event.preventDefault();
          this.open(opener);
          return;
        }
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }
        const quantityButton = event.target.closest('[data-cart-quantity]');
        if (quantityButton) {
          event.preventDefault();
          const line = quantityButton.closest('[data-cart-line]');
          this.changeLine(line, Number.parseInt(quantityButton.dataset.quantity, 10), `[data-line-key="${CSS.escape(line.dataset.lineKey)}"] [data-cart-quantity-action="${quantityButton.dataset.cartQuantityAction}"]`);
          return;
        }
        const removeButton = event.target.closest('[data-cart-remove]');
        if (removeButton) {
          event.preventDefault();
          this.changeLine(removeButton.closest('[data-cart-line]'), 0);
        }
      }
      handleChange(event) {
        const input = event.target.closest('[data-cart-quantity-input]');
        if (!input) return;
        const line = input.closest('[data-cart-line]');
        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        this.changeLine(line, quantity, `[data-line-key="${CSS.escape(line.dataset.lineKey)}"] [data-cart-quantity-input]`);
      }
      async handleSubmit(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action.includes('/cart/add')) return;
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        const submitter = event.submitter || form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-product-status]');
        form.setAttribute('aria-busy', 'true');
        if (submitter) submitter.disabled = true;
        if (status) {
          status.textContent = '';
          status.classList.add('visually-hidden');
        }
        try {
          const body = new FormData(form);
          body.append('sections', this.sectionIds());
          body.append('sections_url', window.location.pathname);
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body
          });
          const data = await this.readResponse(response);
          const cartState = await this.fetchCart();
          this.updateHeaderCount(cartState.item_count);
          this.replaceSections(data.sections, true, submitter);
          this.announce(this.dataset.addedMessage);
        } catch (error) {
          if (status) {
            status.textContent = error.message || this.dataset.errorMessage;
            status.classList.remove('visually-hidden');
          }
          this.announce(error.message || this.dataset.errorMessage);
        } finally {
          form.removeAttribute('aria-busy');
          if (submitter) submitter.disabled = false;
        }
      }
      async changeLine(line, quantity, focusSelector) {
        if (!line || line.getAttribute('aria-busy') === 'true') return;
        line.setAttribute('aria-busy', 'true');
        line.querySelectorAll('button,input').forEach((control) => control.disabled = true);
        try {
          const response = await fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: line.dataset.lineKey,
              quantity,
              sections: this.sectionIds(),
              sections_url: window.location.pathname
            })
          });
          const data = await this.readResponse(response);
          this.updateHeaderCount(data.item_count);
          this.replaceSections(data.sections, this.dialog?.open, this.returnFocusTo, focusSelector);
          const updatedMessage = data.item_count === 1 ? this.dataset.updatedOneMessage : this.dataset.updatedOtherMessage;
          this.announce(updatedMessage.replace('__COUNT__', data.item_count));
        } catch (error) {
          line.removeAttribute('aria-busy');
          line.querySelectorAll('button,input').forEach((control) => control.disabled = false);
          const errorElement = line.querySelector('[data-cart-line-error]');
          if (errorElement) {
            errorElement.textContent = error.message || this.dataset.errorMessage;
            errorElement.hidden = false;
          }
          this.announce(error.message || this.dataset.errorMessage);
        }
      }
      sectionIds() {
        const ids = [this.dataset.sectionId];
        const cartPage = document.querySelector('[data-cart-page]');
        if (cartPage?.dataset.sectionId) ids.push(cartPage.dataset.sectionId);
        return ids.join(',');
      }
      async readResponse(response) {
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.dataset.errorMessage);
        return data;
      }
      async fetchCart() {
        const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        return this.readResponse(response);
      }
      replaceSections(sections, shouldOpen, returnFocusTo, focusSelector) {
        if (!sections) return;
        const cartPage = document.querySelector('[data-cart-page]');
        const cartPageId = cartPage?.dataset.sectionId;
        if (cartPageId && sections[cartPageId]) {
          const pageDocument = new DOMParser().parseFromString(sections[cartPageId], 'text/html');
          const replacementPage = pageDocument.querySelector('[data-cart-page]');
          if (replacementPage) cartPage.replaceWith(replacementPage);
        }
        const drawerHtml = sections[this.dataset.sectionId];
        if (!drawerHtml) return;
        const drawerDocument = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const replacement = drawerDocument.querySelector('seriva-cart-drawer');
        if (!replacement) return;
        this.replaceWith(replacement);
        replacement.pointerFocus = this.pointerFocus;
        requestAnimationFrame(() => {
          if (shouldOpen) replacement.open(returnFocusTo, focusSelector);
          if (!shouldOpen && focusSelector) document.querySelector(`[data-cart-page] ${focusSelector}`)?.focus();
        });
      }
      updateHeaderCount(count) {
        document.querySelectorAll('[data-cart-open]').forEach((opener) => {
          const badge = opener.querySelector('[data-cart-count]');
          if (badge) {
            badge.textContent = count;
            badge.hidden = count === 0;
          }
          const template = opener.dataset.cartLabelTemplate;
          if (template) opener.setAttribute('aria-label', template.replace('__COUNT__', count));
        });
      }
      open(opener, focusSelector) {
        if (!this.dialog || this.dialog.open) return;
        this.returnFocusTo = opener || this.returnFocusTo || document.activeElement;
        this.closeButton?.toggleAttribute('data-drawer-pointer-focus', this.pointerFocus);
        this.dialog.showModal();
        document.body.classList.add('is-scroll-locked');
        document.querySelectorAll('[data-cart-open]').forEach((element) => element.setAttribute('aria-expanded', 'true'));
        const focusTarget = focusSelector ? this.querySelector(focusSelector) : this.closeButton;
        focusTarget?.focus();
      }
      close() {
        if (this.dialog?.open) this.dialog.close();
      }
      afterClose() {
        document.querySelectorAll('[data-cart-open]').forEach((element) => element.setAttribute('aria-expanded', 'false'));
        if (!document.querySelector('dialog[open]')) document.body.classList.remove('is-scroll-locked');
        if (this.returnFocusTo?.isConnected) this.returnFocusTo.focus();
      }
      handleKeydown(event) {
        this.pointerFocus = false;
        this.closeButton?.removeAttribute('data-drawer-pointer-focus');
        if (!this.dialog?.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter((element) => element.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (!this.dialog.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
      }
      announce(message) {
        const liveRegion = document.querySelector('[data-seriva-live-region]');
        if (!liveRegion) return;
        liveRegion.textContent = '';
        requestAnimationFrame(() => liveRegion.textContent = message);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const initializeSerivaCatalogSwipe = (root = document) => {
    root.querySelectorAll('[data-seriva-catalog-swipe]:not([data-seriva-catalog-swipe-ready])').forEach((catalog) => {
      catalog.setAttribute('data-seriva-catalog-swipe-ready', 'true');

      const navigation = catalog.querySelector('.seriva-catalog__navigation');
      const links = navigation ? Array.from(navigation.querySelectorAll('a')) : [];
      const currentIndex = links.findIndex((link) => link.getAttribute('aria-current') === 'page');

      if (currentIndex < 0) return;

      let startX = null;
      let startY = null;

      const resetGesture = () => {
        startX = null;
        startY = null;
      };

      let pointerId = null;

      catalog.addEventListener('pointerdown', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches || !event.isPrimary || event.target.closest('.seriva-catalog__navigation')) {
          resetGesture();
          return;
        }

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
      });

      catalog.addEventListener('pointerup', (event) => {
        if (event.pointerId !== pointerId || startX === null || startY === null) {
          resetGesture();
          return;
        }

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        const horizontalDistance = Math.abs(deltaX);
        const verticalDistance = Math.abs(deltaY);

        pointerId = null;
        resetGesture();

        if (horizontalDistance < 45 || horizontalDistance <= verticalDistance * 1.25) return;

        const nextIndex = currentIndex + (deltaX < 0 ? 1 : -1);
        const nextLink = links[nextIndex];

        if (nextLink) nextLink.click();
      });

      catalog.addEventListener('pointercancel', () => {
        pointerId = null;
        resetGesture();
      });
    });
  };

  initializeSerivaCatalogSwipe();
  document.addEventListener('shopify:section:load', (event) => initializeSerivaCatalogSwipe(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('seriva-header')) {
    customElements.define('seriva-header', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.openButton = this.querySelector('[data-menu-open]');
        this.dialog = this.querySelector('[data-mobile-menu]');
        this.closeButton = this.querySelector('[data-menu-close]');
        this.pointerFocus = false;
        this.mobileSearchForm = this.querySelector('.mobile-menu__search');
        this.mobileSearchInput = this.mobileSearchForm?.querySelector('input[type="search"]');
        this.mobileShopButtons = [...this.querySelectorAll('[data-mobile-shop-toggle]')];
        this.desktopGroups = [...this.querySelectorAll('[data-desktop-nav-group]')];
        this.openButton?.addEventListener('click', () => this.open(), { signal });
        this.closeButton?.addEventListener('click', () => this.close(), { signal });
        this.mobileSearchInput?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.mobileSearchForm?.requestSubmit();
        }, { signal });
        this.dialog?.addEventListener('close', () => this.afterClose(), { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        }, { signal });
        this.mobileShopButtons.forEach((button) => {
          button.addEventListener('click', () => this.setMobileShop(button, button.getAttribute('aria-expanded') !== 'true'), { signal });
        });
        this.desktopGroups.forEach((group) => {
          const button = group.querySelector('[data-desktop-menu-toggle]');
          button?.addEventListener('click', () => this.setDesktopGroup(group, button.getAttribute('aria-expanded') !== 'true'), { signal });
          group.addEventListener('pointerenter', () => this.scheduleDesktopOpen(group), { signal });
          group.addEventListener('pointerleave', () => this.scheduleDesktopClose(group), { signal });
          group.addEventListener('focusout', () => {
            requestAnimationFrame(() => {
              if (!group.contains(document.activeElement)) this.setDesktopGroup(group, false);
            });
          }, { signal });
        });
        document.addEventListener('pointerdown', (event) => {
          this.pointerFocus = true;
          if (!event.target.closest('[data-desktop-nav-group]')) this.closeDesktopMenus();
        }, { signal });
        document.addEventListener('keydown', (event) => {
          this.pointerFocus = false;
          this.closeButton?.removeAttribute('data-drawer-pointer-focus');
          if (event.key === 'Tab') {
            if (this.dialog?.open) this.trapDialogFocus(event);
            return;
          }
          if (event.key !== 'Escape') return;
          if (this.dialog?.open) {
            event.preventDefault();
            this.close();
            return;
          }
          const openGroup = this.querySelector('[data-desktop-nav-group] [aria-expanded="true"]')?.closest('[data-desktop-nav-group]');
          if (!openGroup) return;
          event.preventDefault();
          const button = openGroup.querySelector('[data-desktop-menu-toggle]');
          this.setDesktopGroup(openGroup, false);
          button?.focus();
        }, { signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        document.body.classList.remove('is-scroll-locked');
      }
      open() {
        if (!this.dialog || this.dialog.open) return;
        this.closeDesktopMenus();
        this.mobileShopButtons.forEach((button) => this.setMobileShop(button, false));
        this.closeButton?.toggleAttribute('data-drawer-pointer-focus', this.pointerFocus);
        this.dialog.showModal();
        this.openButton?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('is-scroll-locked');
        this.closeButton?.focus();
      }
      close() {
        if (this.dialog?.open) this.dialog.close();
      }
      afterClose() {
        this.openButton?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('is-scroll-locked');
        this.mobileShopButtons.forEach((button) => this.setMobileShop(button, false));
        this.openButton?.focus();
      }
      setMobileShop(button, open) {
        const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        button.setAttribute('aria-expanded', String(open));
        if (panel) panel.hidden = !open;
      }
      setDesktopGroup(group, open) {
        window.clearTimeout(group.openTimer);
        window.clearTimeout(group.closeTimer);
        if (open) {
          this.desktopGroups.forEach((other) => {
            if (other !== group) this.setDesktopGroup(other, false);
          });
        }
        const button = group.querySelector('[data-desktop-menu-toggle]');
        const panel = group.querySelector('[data-desktop-menu-panel]');
        button?.setAttribute('aria-expanded', String(open));
        if (panel) panel.hidden = !open;
      }
      scheduleDesktopOpen(group) {
        window.clearTimeout(group.closeTimer);
        window.clearTimeout(group.openTimer);
        group.openTimer = window.setTimeout(() => this.setDesktopGroup(group, true), 100);
      }
      scheduleDesktopClose(group) {
        window.clearTimeout(group.openTimer);
        window.clearTimeout(group.closeTimer);
        group.closeTimer = window.setTimeout(() => this.setDesktopGroup(group, false), 120);
      }
      closeDesktopMenus() {
        this.desktopGroups.forEach((group) => this.setDesktopGroup(group, false));
      }
      trapDialogFocus(event) {
        const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')].filter((element) => element.getClientRects().length);
        if (!focusable.length) return;
        const currentIndex = focusable.indexOf(document.activeElement);
        const direction = event.shiftKey ? -1 : 1;
        const nextIndex = currentIndex < 0 ? 0 : (currentIndex + direction + focusable.length) % focusable.length;
        event.preventDefault();
        focusable[nextIndex]?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reference-prototype"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seriva-prototype-tabs')) {
    customElements.define('seriva-prototype-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.prototypeTabsReady === 'true') return;
        this.dataset.prototypeTabsReady = 'true';
        this.tabs = [...this.querySelectorAll('[data-prototype-tab]')];
        this.panels = [...this.querySelectorAll('[data-prototype-panel]')];
        this.tablist = this.querySelector('[role="tablist"]');
        this.selectedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        if (this.selectedIndex < 0) this.selectedIndex = 0;
        this.touchStart = null;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const offset = event.key === 'ArrowRight' ? 1 : -1;
            const nextIndex = (index + offset + this.tabs.length) % this.tabs.length;
            this.select(nextIndex);
            this.tabs[nextIndex].focus();
          });
        });
        if (this.hasAttribute('data-prototype-swipe')) {
          this.panels.forEach((panel) => {
            panel.addEventListener('touchstart', (event) => this.startSwipe(event), { passive: true });
            panel.addEventListener('touchend', (event) => this.endSwipe(event), { passive: true });
            panel.addEventListener('touchcancel', () => this.cancelSwipe(), { passive: true });
          });
        }
        this.updateIndicator(this.selectedIndex, false);
        if ('ResizeObserver' in window && this.tablist) {
          this.indicatorObserver = new ResizeObserver(() => this.updateIndicator(this.selectedIndex, false));
          this.indicatorObserver.observe(this.tablist);
        }
      }
      disconnectedCallback() {
        this.indicatorObserver?.disconnect();
      }
      startSwipe(event) {
        if (!window.matchMedia('(max-width: 749px)').matches || event.touches.length !== 1) {
          this.touchStart = null;
          return;
        }
        const touch = event.touches[0];
        this.touchStart = { x: touch.clientX, y: touch.clientY };
      }
      endSwipe(event) {
        if (!this.touchStart || event.changedTouches.length !== 1) {
          this.touchStart = null;
          return;
        }
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStart.x;
        const deltaY = touch.clientY - this.touchStart.y;
        this.touchStart = null;
        const horizontalDistance = Math.abs(deltaX);
        const verticalDistance = Math.abs(deltaY);
        if (horizontalDistance < 45 || horizontalDistance <= verticalDistance * 1.25) return;
        const selectedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        const nextIndex = selectedIndex + (deltaX < 0 ? 1 : -1);
        if (nextIndex < 0 || nextIndex >= this.tabs.length) return;
        this.select(nextIndex);
      }
      cancelSwipe() {
        this.touchStart = null;
      }
      select(selectedIndex) {
        if (selectedIndex < 0 || selectedIndex >= this.tabs.length || selectedIndex === this.selectedIndex) return;
        const previousIndex = this.selectedIndex;
        this.selectedIndex = selectedIndex;
        this.tabs.forEach((tab, index) => {
          const selected = index === selectedIndex;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          const panel = this.panels[index];
          if (!panel) return;
          panel.classList.remove('is-entering');
          panel.hidden = !selected;
          if (selected) {
            panel.style.setProperty('--seriva-tab-enter-x', selectedIndex > previousIndex ? '.25rem' : '-.25rem');
            panel.classList.add('is-entering');
          }
        });
        this.updateIndicator(selectedIndex, true);
      }
      updateIndicator(selectedIndex, animate) {
        const selectedTab = this.tabs[selectedIndex];
        if (!this.tablist || !selectedTab) return;
        if (!animate) this.tablist.style.setProperty('--seriva-tab-indicator-transition', 'none');
        this.tablist.style.setProperty('--seriva-tab-indicator-x', `${selectedTab.offsetLeft}px`);
        this.tablist.style.setProperty('--seriva-tab-indicator-width', `${selectedTab.offsetWidth}px`);
        if (!animate) {
          this.tablist.getBoundingClientRect();
          this.tablist.style.removeProperty('--seriva-tab-indicator-transition');
        }
      }
    });
  }

  const enhanceSerumReviews = (root = document) => {
    const selector = '.pdp-reference__container--serum-reviews';
    const scopes = [];

    if (root instanceof Element && root.matches(selector)) scopes.push(root);
    root.querySelectorAll?.(selector).forEach((scope) => scopes.push(scope));

    scopes.forEach((scope) => {
      const enhance = () => {
        scope.querySelectorAll('[data-seriva-review-count], [data-seriva-review-frequency]').forEach((countElement) => {
          if (countElement.dataset.serivaReviewCountFormatted === 'true') return;
          const count = Number.parseInt(countElement.dataset.serivaReviewCount || countElement.dataset.serivaReviewFrequency, 10);
          if (Number.isFinite(count)) countElement.textContent = new Intl.NumberFormat('en-US').format(count);
          countElement.dataset.serivaReviewCountFormatted = 'true';
        });

        const filterLabel = scope.querySelector('.jm-custom-answer-filter__text');
        if (filterLabel && !filterLabel.textContent.trim()) filterLabel.textContent = scope.dataset.serivaFiltersLabel;

        const sortFilter = scope.querySelector('.jm-sort-filter');
        if (sortFilter) sortFilter.dataset.serivaSortLabel = scope.dataset.serivaSortLabel;

        scope.querySelectorAll('.jm-review-item').forEach((review) => {
          const details = review.querySelector('.jm-reviewer-info__details');
          if (!details || details.querySelector('.seriva-review-verified')) return;

          const nameCluster = details.querySelector(':scope > .jm-cluster:first-child');
          const dateCluster = details.querySelector(':scope > .jm-cluster:last-child');
          if (!nameCluster || !dateCluster) return;

          const verified = document.createElement('span');
          verified.className = 'seriva-review-verified';
          const mark = document.createElement('span');
          mark.className = 'seriva-review-verified__mark';
          mark.setAttribute('aria-hidden', 'true');
          mark.textContent = '✓';
          verified.append(mark, document.createTextNode(scope.dataset.serivaVerifiedLabel));
          details.insertBefore(verified, dateCluster);
        });
      };

      enhance();
      if (scope.dataset.serivaReviewSummaryObserved === 'true') return;
      scope.dataset.serivaReviewSummaryObserved = 'true';
      new MutationObserver(enhance).observe(scope, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceSerumReviews());
  } else {
    enhanceSerumReviews();
  }
  document.addEventListener('shopify:section:load', (event) => enhanceSerumReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-final-close"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seriva-product-close')) {
    customElements.define('seriva-product-close', class extends HTMLElement {
      connectedCallback() {
        this.variant = this.querySelector('[data-close-variant]');
        this.quantity = this.querySelector('[data-close-quantity]');
        this.listener = (event) => {
          if (event.detail.variantId) this.variant.value = event.detail.variantId;
          if (event.detail.quantity) this.quantity.value = event.detail.quantity;
        };
        document.addEventListener('seriva:product-state', this.listener);
      }
      disconnectedCallback() {
        document.removeEventListener('seriva:product-state', this.listener);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('seriva-gallery')) {
    customElements.define('seriva-gallery', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.previousElementSibling;
        this.slides = [...(this.viewport?.querySelectorAll('.product-gallery__item') || [])];
        this.current = this.querySelector('[data-gallery-current]');
        this.status = this.querySelector('[data-gallery-status]');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        if (!this.viewport || !this.current || !this.status || this.slides.length < 2) return;

        this.mobile = window.matchMedia('(max-width:989px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
        this.index = 0;
        this.announcedIndex = 0;
        this.targetIndex = null;
        this.onScroll = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.syncVisual(this.nearestIndex());
            this.scheduleSettle();
          });
        };
        this.onScrollEnd = () => this.settle();
        this.onPrevious = () => this.moveBy(-1);
        this.onNext = () => this.moveBy(1);
        this.onKeyDown = (event) => {
          if (event.target !== this.viewport || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.moveBy(event.key === 'ArrowLeft' ? -1 : 1);
        };
        this.onBreakpoint = () => {
          this.targetIndex = null;
          if (this.mobile.matches) this.syncVisual(this.nearestIndex());
        };
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('scrollend', this.onScrollEnd);
        this.viewport.addEventListener('keydown', this.onKeyDown);
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.mobile.addEventListener('change', this.onBreakpoint);
        this.syncVisual(this.nearestIndex());
      }
      disconnectedCallback() {
        if (!this.viewport || !this.onScroll) return;
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('scrollend', this.onScrollEnd);
        this.viewport.removeEventListener('keydown', this.onKeyDown);
        this.previous.removeEventListener('click', this.onPrevious);
        this.next.removeEventListener('click', this.onNext);
        this.mobile.removeEventListener('change', this.onBreakpoint);
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.settleTimer);
      }
      nearestIndex() {
        const offset = this.viewport.scrollLeft;
        const origin = this.slides[0].offsetLeft;
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const delta = Math.abs(slide.offsetLeft - origin - offset);
          if (delta < distance) {
            distance = delta;
            nearest = index;
          }
        });
        return nearest;
      }
      syncVisual(index) {
        this.index = index;
        this.current.textContent = String(index + 1).padStart(2, '0');
        this.previous.setAttribute('aria-disabled', String(index === 0));
        this.next.setAttribute('aria-disabled', String(index === this.slides.length - 1));
      }
      scheduleSettle() {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 180);
      }
      settle() {
        clearTimeout(this.settleTimer);
        const index = this.nearestIndex();
        this.syncVisual(index);
        this.targetIndex = null;
        if (index === this.announcedIndex) return;
        this.announcedIndex = index;
        this.status.textContent = this.dataset.announcementTemplate.replace('__current__', String(index + 1));
      }
      moveBy(delta) {
        if (!this.mobile.matches) return;
        const from = this.targetIndex ?? this.index;
        const index = Math.max(0, Math.min(this.slides.length - 1, from + delta));
        if (index === from) return;
        this.targetIndex = index;
        this.viewport.scrollTo({
          left: this.slides[index].offsetLeft - this.slides[0].offsetLeft,
          behavior: this.reducedMotion.matches ? 'instant' : 'smooth'
        });
        this.syncVisual(index);
        this.scheduleSettle();
      }
    });
  }
  if (!customElements.get('seriva-product')) {
    customElements.define('seriva-product', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.formButton = this.form?.querySelector('[data-atc]');
        this.variantSelect = this.querySelector('[data-variant-select]');
        this.supplyOptions = [...this.querySelectorAll('[data-supply-option]')];
        this.quantity = this.querySelector('[data-quantity]');
        this.buttons = this.querySelectorAll('[data-atc]');
        this.price = this.querySelector('[data-product-price] .price__current');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.sticky = this.querySelector('[data-product-sticky]');
        this.stickyButton = this.sticky?.querySelector('[data-atc]');
        this.quantityDecrease = this.querySelector('[data-quantity-decrease]');
        this.quantityIncrease = this.querySelector('[data-quantity-increase]');
        this.guaranteeDetails = this.querySelector('[data-guarantee-details]');
        this.guaranteeDisclosure = this.querySelector('.product-disclosures__shipping');
        this.guaranteeContent = this.querySelector('[data-guarantee-content]');
        const reviewAverage = this.querySelector('[data-product-review-average]');
        const reviewCount = this.querySelector('[data-product-review-count]');
        const reviewAverageValue = Number.parseFloat(reviewAverage?.dataset.productReviewAverage);
        const reviewCountValue = Number.parseInt(reviewCount?.dataset.productReviewCount, 10);
        if (reviewAverage && Number.isFinite(reviewAverageValue)) reviewAverage.textContent = reviewAverageValue.toFixed(1);
        if (reviewCount && Number.isFinite(reviewCountValue)) reviewCount.textContent = new Intl.NumberFormat('en-US').format(reviewCountValue);
        this.variantSelect?.addEventListener('change', () => this.syncVariant());
        this.supplyOptions.forEach((option) => {
          if (option.dataset.enhanceable === 'true') option.disabled = false;
          option.addEventListener('change', () => this.syncSupply(option));
        });
        this.quantity?.addEventListener('change', () => this.normalizeQuantity());
        this.quantityDecrease?.addEventListener('click', () => this.stepQuantity(-1));
        this.quantityIncrease?.addEventListener('click', () => this.stepQuantity(1));
        this.guaranteeDetails?.addEventListener('click', () => this.revealGuarantee());
        if (this.supplyOptions.length) {
          this.syncSupply(this.supplyOptions.find((option) => option.checked));
          this.stickyButton?.addEventListener('click', (event) => {
            event.preventDefault();
            this.form?.requestSubmit(this.formButton);
          });
        } else {
          this.syncVariant();
        }
        if (this.sticky && this.form) {
          this.observer = new IntersectionObserver(([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.sticky.classList.toggle('is-visible', passed);
          }, { threshold: 0 });
          this.observer.observe(this.form);
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      syncVariant() {
        const option = this.variantSelect?.selectedOptions[0];
        const available = option ? option.dataset.available === 'true' : !this.buttons[0]?.disabled;
        const price = option?.dataset.price || this.dataset.currentPrice;
        this.unitPriceCents = Number.parseInt(option?.dataset.priceCents || this.dataset.currentPriceCents, 10);
        this.syncPurchaseState(available, price);
      }
      syncSupply(option) {
        if (!option) return;
        const available = option.dataset.available === 'true' && !option.disabled;
        this.syncPurchaseState(available, option.dataset.price, option.dataset.stickyLabel);
      }
      syncPurchaseState(available, price, stickyLabel) {
        this.buttons.forEach((button) => {
          button.disabled = !available;
          const label = button.querySelector('[data-atc-label]');
          const mainButtonUsesSimpleLabel = button === this.formButton
            && (this.classList.contains('product-main--serum') || this.classList.contains('product-main--supporting'));
          let addLabel = `${this.dataset.addLabel} — ${price}`;
          if (mainButtonUsesSimpleLabel) addLabel = this.dataset.addLabel;
          if (button === this.stickyButton && stickyLabel) addLabel = stickyLabel;
          if (label) label.textContent = available ? addLabel : this.dataset.soldLabel;
        });
        if (price && this.price) this.price.textContent = price;
        if (price && this.stickyPrice) this.stickyPrice.textContent = price;
        this.syncQuantityTotal();
        this.emitState();
      }
      normalizeQuantity() {
        if (!this.quantity) return;
        const normalized = Math.max(1, Number.parseInt(this.quantity.value, 10) || 1);
        this.quantity.value = normalized;
        if (this.quantityDecrease) this.quantityDecrease.disabled = normalized <= 1;
        this.syncQuantityTotal();
        this.emitState();
      }
      stepQuantity(change) {
        if (!this.quantity) return;
        this.quantity.value = Math.max(1, (Number.parseInt(this.quantity.value, 10) || 1) + change);
        this.normalizeQuantity();
      }
      revealGuarantee() {
        if (!this.guaranteeDisclosure || !this.guaranteeContent) return;
        this.guaranteeDisclosure.open = true;
        requestAnimationFrame(() => {
          this.guaranteeContent.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          this.guaranteeContent.focus({ preventScroll: true });
        });
      }
      syncQuantityTotal() {
        if (this.classList.contains('product-main--serum') || this.classList.contains('product-main--supporting')) return;
        if (!Number.isFinite(this.unitPriceCents)) return;
        const quantity = Math.max(1, Number.parseInt(this.quantity?.value, 10) || 1);
        const total = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: this.dataset.currencyCode || 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format((this.unitPriceCents * quantity) / 100);
        const label = this.formButton?.querySelector('[data-atc-label]');
        if (label && !this.formButton.disabled) label.textContent = `${this.dataset.addLabel} — ${total}`;
      }
      emitState() {
        const variantId = this.variantSelect?.value || this.form?.querySelector('[name="id"]:checked')?.value || this.form?.querySelector('[name="id"]')?.value;
        document.dispatchEvent(new CustomEvent('seriva:product-state', {
          detail: { variantId, quantity: this.quantity?.value || 1 }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
